import "../components/ContactFormStyles.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Contact() {
  return (
    <div className="contact-page">
      <Navbar />
      <main className="contact-shell">
        <section className="contact-hero">
          <h1>Contact</h1>
          <p>
            Questions about sanctions, CFIUS, or compliance strategy? We respond within 24
            hours.
          </p>
          <a className="contact-email-link" href="mailto:contact@friggacg.com">
            contact@friggacg.com
          </a>
        </section>

        <section className="contact-grid">
          <article className="contact-card contact-company-card">
            <h2>Frigga Consulting Group</h2>
            <p>Washington, DC</p>
            <p>United States</p>
            <p className="contact-meta">DUNS: 118853578</p>
            <p className="contact-meta">UEI: P7HSRBV492F2</p>
          </article>

          <article className="contact-card contact-map-card">
            <h2>Location</h2>
            <div className="map-frame-wrap">
              <iframe
                title="Frigga Consulting Group Location"
                src="https://www.google.com/maps?q=Washington,+DC&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="map-iframe"
              ></iframe>
            </div>
            <a
              className="contact-map-link"
              href="https://maps.google.com/?q=Washington,+DC"
              target="_blank"
              rel="noreferrer"
            >
              Open in Google Maps
            </a>
          </article>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Contact;
